/**!
 * Created by Leonardo Cheslacki on 09/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StudentController from './StudentController';

import WithType from './../helpers/WithType';

import config from './../../../../config';

const {default: {routes: {api, web}}} = config;

let _this = {};

/**
 *
 */
class StudentSchool extends StudentController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {},
            element: null
        };

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param _id
         */
        handleReadFile: function (event, {_id}) {
            const {data} = _this.state;

            let schools = _this.verifyField(data, 'classroom_student.year.schools'),
                {attachment: {formatted_path}} = _this.findDataId(schools, _id);

            _this.downloadFile(formatted_path);
        }
    };

    /**
     *
     * @param uri
     */
    downloadFile = (uri) => {
        const a = document.createElement('a');

        a.setAttributeNode(document.createAttribute('download'));

        a.href = uri;

        a.click();
    };

    setMenuFiles = () => {
        const
            _this_frame = this.getFrame(),
            {data} = this.state,
            array = this.verifyField(data, 'classroom_student.year.schools');

        for (let i = 0; i < array.length; i++) {
            let
                occurrence = this.padWithLeadingZeros((i + 1), 2),
                item = array[i],
                {id, attachment: {name}} = item;

            _this_frame[`occ_title_${occurrence}`].text = name;
            this.addImage(_this_frame[`occ_menu_${occurrence}`], item);

            this[`_handleReadAttachment${occurrence}A`] && _this_frame[`btn_menu_${occurrence}A`].off('mousedown', this[`_handleReadAttachment${occurrence}A`]);
            this[`_handleReadAttachment${occurrence}A`] = _this_frame[`btn_menu_${occurrence}A`].on('mousedown', this.$functions.handleReadFile, false, false, {_id: id});

            this[`_handleReadAttachment${occurrence}B`] && _this_frame[`btn_menu_${occurrence}B`].off('mousedown', this[`_handleReadAttachment${occurrence}B`]);
            this[`_handleReadAttachment${occurrence}B`] = _this_frame[`btn_menu_${occurrence}B`].on('mousedown', this.$functions.handleReadFile, false, false, {_id: id});
        }
    };

    startFiles = () => {
        const {button_menu_files} = this.props;

        this.setNavbar();

        this.setMenuFiles();

        this.setActions(button_menu_files);
    };

    initFiles = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_school_files}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startFiles);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StudentSchool.propTypes = {
    current_name: PropTypes.string,
    button_navbar: PropTypes.array,
    button_menu_files: PropTypes.array
};

/**
 *
 * @type {{}}
 */
StudentSchool.defaultProps = {
    current_name: null,
    button_navbar: [
        {
            occ: 'profile',
            uri: web.uri_profile
        },
        {
            occ: 'dashboard',
            uri: web.uri_dashboard
        },
        {
            occ: 'logout',
            uri: web.uri_logout
        }
    ],
    button_menu_files: [
        {
            occ: 'back',
            uri: web.uri_dashboard
        }
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StudentSchool, {className: 'StudentSchool'});
